import axiosInstance from 'plugins/axios';
import { INotificationResponse } from 'types/notification';
import { IBodyResponse } from 'types/type.global';

export const getNotifications = async (params: {
    page: number;
    per_page: number;
}): Promise<IBodyResponse<INotificationResponse>> => {
    const response = await axiosInstance.get('/admin/admin_notifications', {
        params,
    });
    return response.data;
};

export const readNotificationById = async (
    id: string
): Promise<IBodyResponse<unknown>> => {
    const res = await axiosInstance.post(
        `/admin/admin_notifications/${id}/read`
    );
    return res.data;
};

export const readAllNotification = async (): Promise<
    IBodyResponse<unknown>
> => {
    const res = await axiosInstance.post(`/admin/admin_notifications/read_all`);
    return res.data;
};
